import React, { useEffect, useState } from "react";
import Autosuggest from "react-autosuggest";

const getSuggestions = (value, items) => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  return inputLength === 0 ? [] : items.filter((item) => item.name.toLowerCase().includes(inputValue));
};

const getSuggestionValue = (suggestion) => suggestion.name;

const renderSuggestion = (suggestion) => {
  return (
    <div className="suggestion-item">
      <strong>{suggestion.name}</strong>
    </div>
  );
};
const CustomAutosuggest = ({
  custodianEntity,
  custodianEntityId,
  custodianEntityName,
  isEditing,
  errors,
  UpdateFields,
}) => {
  const [suggestions, setSuggestions] = useState([]);
  useEffect(() => {
    const name = getCustodyName(custodianEntityId);
    UpdateFields({ custodianEntityName: name });
  }, [custodianEntityId]);

  const handleChange = (event, { newValue }) => {
    if (event.type == "change") {
      UpdateFields({ custodianEntityName: newValue });
    } else if (event.type == "click") {
      const selected = Object.values(custodianEntity).filter((item) => item.name.includes(newValue));

      UpdateFields({ custodianEntityId: selected[0].id });
    }
  };

  const handleSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value, Object.values(custodianEntity)));
  };

  const handleSuggestionsClearRequested = () => {
    setSuggestions([]);
  };
  const getCustodyName = (id) => {
    const items = Object.values(custodianEntity);
    const selectedItem = items.filter((item) => item.id == id);
    return selectedItem[0].name;
  };

  const inputProps = {
    placeholder: "Select ... ",
    value: custodianEntityName || "",
    onChange: handleChange,
    disabled: isEditing,
    style: { background: "#edf9ff", fontWeight: 500 },
  };

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={handleSuggestionsFetchRequested}
      onSuggestionsClearRequested={handleSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      inputProps={inputProps}
    />
  );
};

export default CustomAutosuggest;
